var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 5.146a.55.55 0 0 0 .018.15c.17 1.347.487 2.656.953 3.928a17.922 17.922 0 0 0 4.214 6.595c.938.94 1.954 1.76 3.05 2.461a18.232 18.232 0 0 0 7.47 2.702.55.55 0 0 0 .15.018c.07 0 .116-.006.14-.018a.457.457 0 0 0 .21-.21l1.776-4.456a.392.392 0 0 0-.013-.277.415.415 0 0 0-.18-.207l-4.913-2.46c-.147-.076-.293-.053-.44.07l-2.39 2.417c-1.992-1.23-3.618-2.865-4.877-4.904l2.39-2.39c.123-.147.146-.293.07-.44l-2.46-4.913a.415.415 0 0 0-.207-.18.392.392 0 0 0-.277-.013L3.228 4.794c-.105.059-.166.13-.184.211a.236.236 0 0 0-.044.14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d34a384e076827a79768d07399e09428.svg";
export { ForwardRef as ReactComponent };